import * as i0 from '@angular/core';
import { TemplateRef, Component, ViewEncapsulation, ChangeDetectionStrategy, Input, ViewChild, EventEmitter, ContentChildren, Output, NgModule } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import * as i2 from '@angular/material/button-toggle';
import { MatButtonToggleGroup, MatButtonToggleModule } from '@angular/material/button-toggle';
import { startWith, delay, map } from 'rxjs/operators';
import * as i1 from '@angular/common';
import { CommonModule } from '@angular/common';
function ButtonToggleComponent_ng_template_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵprojection(0);
  }
}
const _c0 = ["*"];
const _c1 = a0 => ({
  disabled: a0
});
const _c2 = a0 => ({
  context: a0
});
function ButtonToggleGroupComponent_mat_button_toggle_2_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0, 7);
  }
  if (rf & 2) {
    const item_r1 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("ngTemplateOutlet", item_r1.titleTemplate)("ngTemplateOutletContext", i0.ɵɵpureFunction1(4, _c2, i0.ɵɵpureFunction1(2, _c1, item_r1.disabled)));
  }
}
function ButtonToggleGroupComponent_mat_button_toggle_2_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const item_r1 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(item_r1.title);
  }
}
function ButtonToggleGroupComponent_mat_button_toggle_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-button-toggle", 3)(1, "span", 4);
    i0.ɵɵtemplate(2, ButtonToggleGroupComponent_mat_button_toggle_2_ng_container_2_Template, 1, 6, "ng-container", 5)(3, ButtonToggleGroupComponent_mat_button_toggle_2_ng_container_3_Template, 2, 1, "ng-container", 6);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const item_r1 = ctx.$implicit;
    i0.ɵɵproperty("aria-label", item_r1.ariaLabel ? item_r1.ariaLabel : item_r1.title ? item_r1.title : item_r1.value)("name", item_r1.name)("checked", item_r1.checked)("id", item_r1.id)("value", item_r1.value)("disabled", item_r1.disabled);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", item_r1.titleTemplate);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", item_r1.title);
  }
}
let buttonToggleCount = 1;
class ButtonToggleComponent {
  constructor() {
    this.title = '';
    this.checked = false;
    this.name = '';
    this.id = `sol-button-toggle-${buttonToggleCount}`;
    this.ariaLabel = null;
    this.value = '';
    this.disabled = false;
    this.titleTemplate = null;
    this.itemContent = null;
    buttonToggleCount++;
  }
  static {
    this.ɵfac = function ButtonToggleComponent_Factory(t) {
      return new (t || ButtonToggleComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: ButtonToggleComponent,
      selectors: [["sol-button-toggle"]],
      viewQuery: function ButtonToggleComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(TemplateRef, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.itemContent = _t.first);
        }
      },
      inputs: {
        title: "title",
        checked: "checked",
        name: "name",
        id: "id",
        ariaLabel: "ariaLabel",
        value: "value",
        disabled: "disabled",
        titleTemplate: "titleTemplate"
      },
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function ButtonToggleComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵtemplate(0, ButtonToggleComponent_ng_template_0_Template, 1, 0, "ng-template");
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ButtonToggleComponent, [{
    type: Component,
    args: [{
      selector: 'sol-button-toggle',
      template: '<ng-template><ng-content></ng-content></ng-template>',
      encapsulation: ViewEncapsulation.None,
      changeDetection: ChangeDetectionStrategy.OnPush
    }]
  }], () => [], {
    title: [{
      type: Input
    }],
    checked: [{
      type: Input
    }],
    name: [{
      type: Input
    }],
    id: [{
      type: Input
    }],
    ariaLabel: [{
      type: Input
    }],
    value: [{
      type: Input
    }],
    disabled: [{
      type: Input
    }],
    titleTemplate: [{
      type: Input
    }],
    itemContent: [{
      type: ViewChild,
      args: [TemplateRef]
    }]
  });
})();
class ButtonToggleGroupComponent {
  constructor(cdr) {
    this.cdr = cdr;
    this.multiple = false;
    this.disabled = false;
    this.name = '';
    this.value = '';
    this.onChangeHandler = _ => {};
    this.onTouchedHandler = () => {};
    this.change = new EventEmitter();
  }
  // controlValueAccessorStart
  writeValue(obj) {
    this.value = obj;
    this.cdr.markForCheck();
  }
  registerOnChange(fn) {
    this.onChangeHandler = fn;
  }
  registerOnTouched(fn) {
    this.onTouchedHandler = fn;
  }
  onChange(value) {
    this.value = value;
    this.onChangeHandler(this.value);
    this.change.emit(this.value);
  }
  // controlValueAccessorEnd
  ngAfterContentInit() {
    this.buttonItems$ = this.buttons.changes.pipe(startWith('')).pipe(delay(0)).pipe(map(() => {
      return this.buttons.toArray();
    }));
  }
  static {
    this.ɵfac = function ButtonToggleGroupComponent_Factory(t) {
      return new (t || ButtonToggleGroupComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: ButtonToggleGroupComponent,
      selectors: [["sol-toggle-group"]],
      contentQueries: function ButtonToggleGroupComponent_ContentQueries(rf, ctx, dirIndex) {
        if (rf & 1) {
          i0.ɵɵcontentQuery(dirIndex, ButtonToggleComponent, 4);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.buttons = _t);
        }
      },
      viewQuery: function ButtonToggleGroupComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(MatButtonToggleGroup, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.tabGroup = _t.first);
        }
      },
      inputs: {
        multiple: "multiple",
        disabled: "disabled",
        name: "name",
        value: "value"
      },
      outputs: {
        change: "change"
      },
      features: [i0.ɵɵProvidersFeature([{
        provide: NG_VALUE_ACCESSOR,
        useExisting: ButtonToggleGroupComponent,
        multi: true
      }])],
      decls: 4,
      vars: 7,
      consts: [[1, "sol-button-toggle-group"], ["disableRipple", "true", 3, "value", "multiple", "disabled", "name", "change"], [3, "aria-label", "name", "checked", "id", "value", "disabled", 4, "ngFor", "ngForOf"], [3, "aria-label", "name", "checked", "id", "value", "disabled"], [1, "icon-text"], [3, "ngTemplateOutlet", "ngTemplateOutletContext", 4, "ngIf"], [4, "ngIf"], [3, "ngTemplateOutlet", "ngTemplateOutletContext"]],
      template: function ButtonToggleGroupComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 0)(1, "mat-button-toggle-group", 1);
          i0.ɵɵlistener("change", function ButtonToggleGroupComponent_Template_mat_button_toggle_group_change_1_listener($event) {
            return ctx.onChange($event.value);
          });
          i0.ɵɵtemplate(2, ButtonToggleGroupComponent_mat_button_toggle_2_Template, 4, 8, "mat-button-toggle", 2);
          i0.ɵɵpipe(3, "async");
          i0.ɵɵelementEnd()();
        }
        if (rf & 2) {
          i0.ɵɵadvance();
          i0.ɵɵproperty("value", ctx.value)("multiple", ctx.multiple)("disabled", ctx.disabled)("name", ctx.name);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngForOf", i0.ɵɵpipeBind1(3, 5, ctx.buttonItems$));
        }
      },
      dependencies: [i1.NgForOf, i1.NgIf, i1.NgTemplateOutlet, i2.MatButtonToggleGroup, i2.MatButtonToggle, i1.AsyncPipe],
      styles: [".sol-button-toggle-group{display:inline-block}.sol-button-toggle-group .mat-button-toggle:first-child,.sol-button-toggle-group .mat-button-toggle:first-child .mat-button-toggle-ripple{border-radius:4px 0 0 4px}.sol-button-toggle-group .mat-button-toggle:first-child .mat-button-toggle-label-content{border-radius:inherit}.sol-button-toggle-group .mat-button-toggle:last-child{border-radius:0 4px 4px 0}.sol-button-toggle-group .mat-button-toggle:last-child .mat-button-toggle-ripple{border-radius:0 4px 4px 0}.sol-button-toggle-group .mat-button-toggle:last-child .mat-button-toggle-label-content{border-radius:inherit}.sol-button-toggle-group .mat-button-toggle-group{box-shadow:0 1px 1px #00000029;overflow:visible}.sol-button-toggle-group .mat-button-toggle-group .mat-button-toggle-appearance-standard{background-color:var(--color-interface-background50)}.sol-button-toggle-group .mat-button-toggle-group .mat-button-toggle-appearance-standard button{box-shadow:0 1px 1px #00000029;border-radius:inherit}.sol-button-toggle-group .mat-button-toggle-group .mat-button-toggle-appearance-standard button .mat-button-toggle-label-content{line-height:1.125rem;padding:.625rem 1rem;font-weight:600;font-family:Open Sans;font-style:normal;font-size:.813rem;display:inline-flex}.sol-button-toggle-group .mat-button-toggle-group .mat-button-toggle-appearance-standard button .mat-button-toggle-label-content .icon-text{gap:var(--gap8);display:inline-flex;align-items:center;color:var(--color-globalstate-inactive-text)}.sol-button-toggle-group .mat-button-toggle-group .mat-button-toggle-appearance-standard button .mat-button-toggle-label-content .icon-text svg path{fill:var(--color-globalstate-inactive-text)}.sol-button-toggle-group .mat-button-toggle-group .mat-button-toggle-appearance-standard button:focus-visible{position:relative;z-index:1;outline:.063rem solid var(--color-globalstate-focus);outline-offset:.25rem;background-color:var(--color-interface-background100)}.sol-button-toggle-group .mat-button-toggle-group .mat-button-toggle-appearance-standard button:focus-visible .mat-button-toggle-label-content .icon-text{color:var(--color-interface-text700)}.sol-button-toggle-group .mat-button-toggle-group .mat-button-toggle-appearance-standard button:focus-visible .mat-button-toggle-label-content .icon-text svg path{fill:var(--color-interface-text700)}.sol-button-toggle-group .mat-button-toggle-group .mat-button-toggle-appearance-standard button:hover{background-color:var(--color-interface-background100)}.sol-button-toggle-group .mat-button-toggle-group .mat-button-toggle-appearance-standard button:hover .mat-button-toggle-label-content .icon-text{color:var(--color-interface-text700)}.sol-button-toggle-group .mat-button-toggle-group .mat-button-toggle-appearance-standard button:hover .mat-button-toggle-label-content .icon-text svg path{fill:var(--color-interface-text700)}.sol-button-toggle-group .mat-button-toggle-group .mat-button-toggle-appearance-standard button:disabled{background:var(--color-globalstate-disabled-background)}.sol-button-toggle-group .mat-button-toggle-group .mat-button-toggle-appearance-standard button:disabled .mat-button-toggle-label-content .icon-text{color:var(--color-globalstate-disabled-border)}.sol-button-toggle-group .mat-button-toggle-group .mat-button-toggle-appearance-standard button:disabled .mat-button-toggle-label-content .icon-text svg path{fill:var(--color-globalstate-disabled-border)}.sol-button-toggle-group .mat-button-toggle-group .mat-button-toggle-checked.mat-button-toggle-appearance-standard,.sol-button-toggle-group .mat-button-toggle-group .mat-button-toggle-checked.mat-button-toggle-appearance-standard .mat-button-toggle-checked{background-color:var(--color-interface-background100)}.sol-button-toggle-group .mat-button-toggle-group .mat-button-toggle-checked.mat-button-toggle-appearance-standard button .mat-button-toggle-label-content,.sol-button-toggle-group .mat-button-toggle-group .mat-button-toggle-checked.mat-button-toggle-appearance-standard .mat-button-toggle-checked button .mat-button-toggle-label-content{padding-bottom:.5rem;border-bottom:2px solid var(--color-interface-blue550)}.sol-button-toggle-group .mat-button-toggle-group .mat-button-toggle-checked.mat-button-toggle-appearance-standard button .mat-button-toggle-label-content .icon-text,.sol-button-toggle-group .mat-button-toggle-group .mat-button-toggle-checked.mat-button-toggle-appearance-standard .mat-button-toggle-checked button .mat-button-toggle-label-content .icon-text{color:var(--color-interface-blue550)}.sol-button-toggle-group .mat-button-toggle-group .mat-button-toggle-checked.mat-button-toggle-appearance-standard button .mat-button-toggle-label-content .icon-text svg path,.sol-button-toggle-group .mat-button-toggle-group .mat-button-toggle-checked.mat-button-toggle-appearance-standard .mat-button-toggle-checked button .mat-button-toggle-label-content .icon-text svg path{fill:var(--color-interface-blue550)}.mat-button-toggle-group-appearance-standard .mat-button-toggle+.mat-button-toggle{border-left:1px solid var(--color-interface-border1)}.mat-button-toggle-standalone.mat-button-toggle-appearance-standard,.mat-button-toggle-group-appearance-standard{border:none}\n"],
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ButtonToggleGroupComponent, [{
    type: Component,
    args: [{
      selector: 'sol-toggle-group',
      changeDetection: ChangeDetectionStrategy.OnPush,
      encapsulation: ViewEncapsulation.None,
      providers: [{
        provide: NG_VALUE_ACCESSOR,
        useExisting: ButtonToggleGroupComponent,
        multi: true
      }],
      template: "<div class=\"sol-button-toggle-group\">\n  <mat-button-toggle-group\n    disableRipple=\"true\"\n    [value]=\"value\"\n    [multiple]=\"multiple\"\n    [disabled]=\"disabled\"\n    [name]=\"name\"\n    (change)=\"onChange($event.value)\"\n  >\n    <mat-button-toggle\n      *ngFor=\"let item of buttonItems$ | async\"\n      [aria-label]=\"item.ariaLabel ? item.ariaLabel : item.title ? item.title : item.value\"\n      [name]=\"item.name\"\n      [checked]=\"item.checked\"\n      [id]=\"item.id\"\n      [value]=\"item.value\"\n      [disabled]=\"item.disabled\"\n    >\n      <span class=\"icon-text\">\n        <ng-container\n          *ngIf=\"item.titleTemplate\"\n          [ngTemplateOutlet]=\"item.titleTemplate\"\n          [ngTemplateOutletContext]=\"{ context: { disabled: item.disabled } }\"\n        ></ng-container>\n        <ng-container *ngIf=\"item.title\">{{ item.title }}</ng-container>\n      </span>\n    </mat-button-toggle>\n  </mat-button-toggle-group>\n</div>\n",
      styles: [".sol-button-toggle-group{display:inline-block}.sol-button-toggle-group .mat-button-toggle:first-child,.sol-button-toggle-group .mat-button-toggle:first-child .mat-button-toggle-ripple{border-radius:4px 0 0 4px}.sol-button-toggle-group .mat-button-toggle:first-child .mat-button-toggle-label-content{border-radius:inherit}.sol-button-toggle-group .mat-button-toggle:last-child{border-radius:0 4px 4px 0}.sol-button-toggle-group .mat-button-toggle:last-child .mat-button-toggle-ripple{border-radius:0 4px 4px 0}.sol-button-toggle-group .mat-button-toggle:last-child .mat-button-toggle-label-content{border-radius:inherit}.sol-button-toggle-group .mat-button-toggle-group{box-shadow:0 1px 1px #00000029;overflow:visible}.sol-button-toggle-group .mat-button-toggle-group .mat-button-toggle-appearance-standard{background-color:var(--color-interface-background50)}.sol-button-toggle-group .mat-button-toggle-group .mat-button-toggle-appearance-standard button{box-shadow:0 1px 1px #00000029;border-radius:inherit}.sol-button-toggle-group .mat-button-toggle-group .mat-button-toggle-appearance-standard button .mat-button-toggle-label-content{line-height:1.125rem;padding:.625rem 1rem;font-weight:600;font-family:Open Sans;font-style:normal;font-size:.813rem;display:inline-flex}.sol-button-toggle-group .mat-button-toggle-group .mat-button-toggle-appearance-standard button .mat-button-toggle-label-content .icon-text{gap:var(--gap8);display:inline-flex;align-items:center;color:var(--color-globalstate-inactive-text)}.sol-button-toggle-group .mat-button-toggle-group .mat-button-toggle-appearance-standard button .mat-button-toggle-label-content .icon-text svg path{fill:var(--color-globalstate-inactive-text)}.sol-button-toggle-group .mat-button-toggle-group .mat-button-toggle-appearance-standard button:focus-visible{position:relative;z-index:1;outline:.063rem solid var(--color-globalstate-focus);outline-offset:.25rem;background-color:var(--color-interface-background100)}.sol-button-toggle-group .mat-button-toggle-group .mat-button-toggle-appearance-standard button:focus-visible .mat-button-toggle-label-content .icon-text{color:var(--color-interface-text700)}.sol-button-toggle-group .mat-button-toggle-group .mat-button-toggle-appearance-standard button:focus-visible .mat-button-toggle-label-content .icon-text svg path{fill:var(--color-interface-text700)}.sol-button-toggle-group .mat-button-toggle-group .mat-button-toggle-appearance-standard button:hover{background-color:var(--color-interface-background100)}.sol-button-toggle-group .mat-button-toggle-group .mat-button-toggle-appearance-standard button:hover .mat-button-toggle-label-content .icon-text{color:var(--color-interface-text700)}.sol-button-toggle-group .mat-button-toggle-group .mat-button-toggle-appearance-standard button:hover .mat-button-toggle-label-content .icon-text svg path{fill:var(--color-interface-text700)}.sol-button-toggle-group .mat-button-toggle-group .mat-button-toggle-appearance-standard button:disabled{background:var(--color-globalstate-disabled-background)}.sol-button-toggle-group .mat-button-toggle-group .mat-button-toggle-appearance-standard button:disabled .mat-button-toggle-label-content .icon-text{color:var(--color-globalstate-disabled-border)}.sol-button-toggle-group .mat-button-toggle-group .mat-button-toggle-appearance-standard button:disabled .mat-button-toggle-label-content .icon-text svg path{fill:var(--color-globalstate-disabled-border)}.sol-button-toggle-group .mat-button-toggle-group .mat-button-toggle-checked.mat-button-toggle-appearance-standard,.sol-button-toggle-group .mat-button-toggle-group .mat-button-toggle-checked.mat-button-toggle-appearance-standard .mat-button-toggle-checked{background-color:var(--color-interface-background100)}.sol-button-toggle-group .mat-button-toggle-group .mat-button-toggle-checked.mat-button-toggle-appearance-standard button .mat-button-toggle-label-content,.sol-button-toggle-group .mat-button-toggle-group .mat-button-toggle-checked.mat-button-toggle-appearance-standard .mat-button-toggle-checked button .mat-button-toggle-label-content{padding-bottom:.5rem;border-bottom:2px solid var(--color-interface-blue550)}.sol-button-toggle-group .mat-button-toggle-group .mat-button-toggle-checked.mat-button-toggle-appearance-standard button .mat-button-toggle-label-content .icon-text,.sol-button-toggle-group .mat-button-toggle-group .mat-button-toggle-checked.mat-button-toggle-appearance-standard .mat-button-toggle-checked button .mat-button-toggle-label-content .icon-text{color:var(--color-interface-blue550)}.sol-button-toggle-group .mat-button-toggle-group .mat-button-toggle-checked.mat-button-toggle-appearance-standard button .mat-button-toggle-label-content .icon-text svg path,.sol-button-toggle-group .mat-button-toggle-group .mat-button-toggle-checked.mat-button-toggle-appearance-standard .mat-button-toggle-checked button .mat-button-toggle-label-content .icon-text svg path{fill:var(--color-interface-blue550)}.mat-button-toggle-group-appearance-standard .mat-button-toggle+.mat-button-toggle{border-left:1px solid var(--color-interface-border1)}.mat-button-toggle-standalone.mat-button-toggle-appearance-standard,.mat-button-toggle-group-appearance-standard{border:none}\n"]
    }]
  }], () => [{
    type: i0.ChangeDetectorRef
  }], {
    multiple: [{
      type: Input
    }],
    disabled: [{
      type: Input
    }],
    name: [{
      type: Input
    }],
    value: [{
      type: Input
    }],
    tabGroup: [{
      type: ViewChild,
      args: [MatButtonToggleGroup]
    }],
    buttons: [{
      type: ContentChildren,
      args: [ButtonToggleComponent]
    }],
    change: [{
      type: Output
    }]
  });
})();
class ButtonToggleGroupModule {
  static {
    this.ɵfac = function ButtonToggleGroupModule_Factory(t) {
      return new (t || ButtonToggleGroupModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: ButtonToggleGroupModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [CommonModule, MatButtonToggleModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ButtonToggleGroupModule, [{
    type: NgModule,
    args: [{
      declarations: [ButtonToggleGroupComponent, ButtonToggleComponent],
      imports: [CommonModule, MatButtonToggleModule],
      exports: [ButtonToggleGroupComponent, ButtonToggleComponent]
    }]
  }], null, null);
})();

/*
 * Public API Surface of toggle-group
 */

/**
 * Generated bundle index. Do not edit.
 */

export { ButtonToggleComponent, ButtonToggleGroupComponent, ButtonToggleGroupModule };
